
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agentura",
      function () {
        return require("private-next-pages/agentura.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agentura"])
      });
    }
  